export default __webpack_public_path__ + "static/media/Seventh.3aa27017.png";